import { betslurpApi } from "./betslurpApi";
import { createSelector } from "@reduxjs/toolkit";
import type {
  TeamMetadataMap,
  TeamMetadataTeam,
} from "@momentum/betslurp-schemas";
import { skipToken } from "@reduxjs/toolkit/query/react";

export const selectTeamMetadataMap = createSelector(
  (metadataMap: TeamMetadataMap) => metadataMap.leagues,
  (leagues) => {
    const teams = new Map<string, TeamMetadataTeam>();
    for (const leagueId in leagues) {
      const league = leagues[leagueId];
      for (const teamId in league.teams) {
        teams.set(teamId, league.teams[teamId]);
      }
    }
    return teams;
  }
);

export const useTeamMetadata = (teamId: string | undefined) =>
  betslurpApi.useTeamMetadataQuery(teamId ? undefined : skipToken, {
    selectFromResult: (result) => {
      return {
        isLoading: result.isLoading,
        data: result.data && selectTeamMetadataMap(result.data).get(teamId!),
      };
    },
  });
